/**
 * @fileoverview Route guard for the accept-invitation page.
 * @description Redirects an already-authenticated visitor to their resolved home route (see
 * `resolveHomeRoute`) — a signed-in visitor clicking an old invitation link has nothing to do on
 * this page, mirroring GuestRoute. This is the "has a session → dashboard" half of the invitation
 * decision table's ACTIVE row; the "no session → /login" half is handled inside
 * AcceptInvitationCard itself, once the account status lookup confirms ACTIVE (a visitor with no
 * session yet can't be told apart from any other unauthenticated visitor before that call
 * resolves).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { Navigate, Outlet } from 'react-router'

import { resolveHomeRoute } from '@/shared/lib/auth/resolve-home-route'
import { useAuth } from '@/shared/lib/auth/useAuth'

/**
 * @component
 */
function InvitationRoute() {
  const { isAuthenticated, user } = useAuth()

  if (isAuthenticated) {
    return <Navigate to={resolveHomeRoute(user?.privileges ?? [])} replace />
  }

  return <Outlet />
}

export default InvitationRoute
